"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_edit__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "1abe020b-9f33-4207-8c83-f3c1f2820646",
    "data-name": "Edit_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63.44 152.94 55.65 155.55 54.75 155.85 47.54 158.27 42.59 159.93 36.42 161.99 34.32 159.89 32.22 157.79 30.12 155.69 32.18 149.52 33.84 144.57 36.26 137.36 36.56 136.46 39.17 128.67 46.45 121.39 70.74 145.68 63.44 152.94",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.52,39.59a17.17,17.17,0,0,0-24.28,0l-8.16,8.16L144.36,72l8.16-8.16A17.17,17.17,0,0,0,152.52,39.59Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.25 50.59 141.53 74.86 144.35 72.03 120.08 47.76 117.25 50.59",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.25 50.59 141.53 74.86 144.35 72.03 120.08 47.76 117.25 50.59",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63.44 152.94 55.65 155.55 54.75 155.85 47.54 158.27 42.59 159.93 36.42 161.99 34.32 159.89 32.22 157.79 30.12 155.69 32.18 149.52 33.84 144.57 36.26 137.36 36.56 136.46 39.17 128.67 46.45 121.39 70.74 145.68 63.44 152.94",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.38,151.91l-3.14,9.37a2,2,0,0,0,2.58,2.58l9.4-3.15Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,129l-.15-.15A.24.24,0,0,0,39.5,129Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,152.88l-.35-.35C63,153,63.17,153,63.38,152.88Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,58.67,54.65,129.35l-7.39,7.39a1.08,1.08,0,0,0,1,.3,5.72,5.72,0,0,1,6.79,6.79,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,58.67,54.65,129.35l-7.39,7.39a1.08,1.08,0,0,0,1,.3,5.72,5.72,0,0,1,6.79,6.79,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,50.58,39.17,128.67l.18.18.15.15a.77.77,0,0,0,.37,0A5.72,5.72,0,0,1,47,135.75a1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.41,66.74,62.72,137.42l-7.39,7.39a1.08,1.08,0,0,0,1,.31,5.72,5.72,0,0,1,6.71,7.12,1.94,1.94,0,0,0,0,.28l.35.35.07.07,78.08-78.08Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.41,66.74,62.72,137.42l-7.39,7.39a1.08,1.08,0,0,0,1,.31,5.72,5.72,0,0,1,6.71,7.12,1.94,1.94,0,0,0,0,.28l.35.35.07.07,78.08-78.08Z",
    opacity: 0.12
  }))), /*#__PURE__*/React.createElement("title", null, "edit-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "8df16ee2-d04a-430a-84a2-1719becc9fdf",
    "data-name": "Edit_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "f7d4908f-64ec-4d8f-bc88-ee8db0e37683",
    "data-name": "Edit_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#1abe020b-9f33-4207-8c83-f3c1f2820646"
  })));
}

var _default = ic_edit__dark;
exports.default = _default;